export const preferredCountries=['ru', 'by', 'kz', 'ua', 'uz', 'az', 'ge', 'tj', 'md', 'am', 'tm', 'kg'];
export const imageExs=['jpg', 'jpeg', 'png', 'gif', 'tiff'];
export const videoExs=['3gp', 'mp4', 'avi', 'amv', 'mpeg', 'mpg', 'm4v', 'webm'];

export const errorMessagesObject = {
    phone: 'Некорректно указан номер телефона'
}

export function getClientId(type) {
    switch(type) {
        case "vk-oauth2":
            return "gz6RXiuUi6UZYxlL5j93My6KkEshrn0m936DJEwv";
        case "facebook":
            return "FwrPkqo80jsrZhMCaWRyRNYOCfABnWNY7mG27KkC";
        case "google-oauth2":
            return "641LH2rbdRnAmd7J8DjdoKRhAsttR0UMTiHAA3PM";
        case "instagram":
            return "QIiDNM6jWZuMuQZn2SMapYEMYCEqrwOrmN9u3EJT";
        case "twitter":
            return "v2rIp5zaYWHM88ZDazWpF9GlT4OlCC55LaiudmcL";
        default:
            return '';
    }
}

export function getClientSecret(type) {
    switch(type) {
        case "vk-oauth2":
            return "jeHIvqONDJKVWGoLA2oRabsKbQ4L6C8Ry2BA6jAvdWKNeJ6WgncI6J0ZybvvFJ6vGrz4CSqBrd4w6s6YYbRQDKOeOJ1OZH5HsVfGQ8lDck4Qtv4Cevp4Rkw1pfB9nbOQ";

        case "facebook":
            return "TGX3mSQ25McVmyKD1ga0mB5SXOBK25rSyi8g2udeih8a2uH11sgKxNtdJVMPKmMppaZTvd2J911sskzo9PESXMheqfs83QcHIAyHaninRlAUBDPRKg7hRt8ZJJ2d85M8";
  
        case "google-oauth2":
            return "yB9i18SlLJBCerIUM3kAl0bVAIgsExQjW697e3Z1lbfHFos6iHOjJUYnele0nnBnuKwlHeUBAVBLszhjdMlMkldWZaEhA67L1mv9CDERNGDf1j4rNUKm0CGB7gYKAaNf";
         
        case "instagram":
            return "lRDmyzFgWAdMHk7LspFCjBQXK4o05lGYkFhxNnCUfCgS6yls3lHhYG8SehLkCJWYHPGA1u5Agsz6MAOJSeHcRk9kvZbKb2M8Lgv6QYF8Ujow4KxGkyEE0OoyG4kA9L76";
        
        case "twitter":
            return "Xrqb6mY23fFe49PYjpKnZggscdRT2OYMklgT37gtlKx6tvIffNnUNAAJYC5HYZbCYgq2oFlxYWIRJOO9JpcQYWzluCFjB2DsbOR1xANXC87xrGXcgCNwEN1MOI5849F4";
        default:
            return '';
    }
}

export const MONTHS = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
];

export const WEEKDAYS_LONG = [
    'Воскресение',
    'Понедельник',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота',
];

export const WEEKDAYS_SHORT = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];


// WEBPACK FOOTER //
// ./src/components/Commons/Constants.js